import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertCircle, FiCheckCircle, FiX, FiCheck } = FiIcons;

const BeforeAfter = () => {
  return (
    <section id="comparison" className="py-20 bg-gradient-to-br from-gray-900 to-black overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            Why Most Trade Websites Fail
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Traditional websites are built for desktop and focus on "about us". <br />
            Our pages are built for mobile and focus on <strong>trust and conversion.</strong>
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Failure Section */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="bg-red-500/5 border border-red-500/20 rounded-2xl p-8 relative"
          >
            <div className="absolute top-4 right-4 bg-red-500/20 p-2 rounded-full">
              <SafeIcon icon={FiX} className="w-5 h-5 text-red-400" />
            </div>
            <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-2">
              <SafeIcon icon={FiAlertCircle} className="text-red-400" />
              Typical Tradie Website
            </h3>
            <ul className="space-y-4">
              {[
                "Cluttered, confusing layout",
                "Generic, blurry stock photos",
                "No clear call to action",
                "Slow and broken on mobile",
                "Looks like every other competitor"
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-white/60">
                  <SafeIcon icon={FiX} className="text-red-500 flex-shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 h-32 bg-white/5 border border-white/10 rounded-lg flex items-center justify-center italic text-white/30 text-sm">
              [ Illustrative Visual: Messy Desktop Layout ]
            </div>
          </motion.div>

          {/* Success Section */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="bg-blue-500/10 border border-blue-500/30 rounded-2xl p-8 relative"
          >
            <div className="absolute top-4 right-4 bg-blue-500/20 p-2 rounded-full">
              <SafeIcon icon={FiCheck} className="w-5 h-5 text-blue-400" />
            </div>
            <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-2">
              <SafeIcon icon={FiCheckCircle} className="text-blue-400" />
              Your BPA Trade Page
            </h3>
            <ul className="space-y-4">
              {[
                "Clean, focused elite layout",
                "Trade-specific messaging",
                "One clear, bold action",
                "Blazing fast on mobile",
                "Built specifically to convert"
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-blue-100">
                  <SafeIcon icon={FiCheck} className="text-blue-400 flex-shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 h-32 bg-blue-500/20 border border-blue-500/30 rounded-lg flex items-center justify-center font-semibold text-blue-200 text-sm">
              [ Illustrative Visual: Clean Mobile Mockup ]
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfter;